module.exports = __webpack_public_path__ + "media/images/press_kit/norwegian_cruise_line_holdings/main-166763d30ce3b8bc177901eaf5139f98.png";